import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { setSampleCode } from "../redux/sampleSlice";
import axios from "axios";

import { encryptId } from "../utils/helpers";

const API_URL = process.env.REACT_APP_API_URL;

export default function User_Dashboard() {
    const navigate = useNavigate();
    const { user: loggedUser } = useAuth();
    const dispatch = useDispatch();
    const [center_list, setCenter_list] = useState([]);
    const [sampleId, setSampleId] = useState("");

    const [userList, setUserList] = useState([]);
    ///////////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState("");
    const [selectedSampleId, setSelectedSampleId] = useState("");
    const [error, setError] = useState("");

    const [isManualSample, setIsManualSample] = useState(false);
    ////////////////////////////////////////////////
    const [form, setForm] = useState({
        center_code: "",
        procedure: "",
        cycle: "",
        donor_sperm: "",
        serial_no: "",
        sample_generated: "",
    });




    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => {
            if (name === "serial_no") {
                const numeric = value.replace(/\D/g, "");
                if (!numeric) return { ...prev, serial_no: "" };
                if (numeric > 999) return { ...prev, serial_no: "" };
                const formatted = parseInt(numeric, 10) < 100 ? String(parseInt(numeric, 10)).padStart(3, "0") : String(parseInt(numeric, 10));
                return { ...prev, serial_no: formatted };
            }
            return { ...prev, [name]: value };
        });
    };

    useEffect(() => {
        if (loggedUser && loggedUser.role !== "1") {
            setForm((prev) => ({
                ...prev,
                center_code: `${loggedUser.center_code}/PIWIL`,
                sample_generated: `${loggedUser.center_code}/PIWIL`,
            }));
        }
    }, [loggedUser]);

    useEffect(() => {
        if (loggedUser?.role !== "1") return;
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.get(`${API_URL}/get_center_list`, { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => setCenter_list(res.data.center_list || []))
            .catch((err) => console.error("Center list error:", err));
    }, [loggedUser]);

    useEffect(() => {
        if (isManualSample) return; // 🔥 Don't auto-generate if user manually edited

        const { center_code, procedure, serial_no, donor_sperm, cycle } = form;

        const donorValue = donor_sperm === "N" ? "" : donor_sperm;

        if (center_code && procedure && serial_no && cycle) {
            const parts = [center_code, procedure, cycle, donorValue, serial_no].filter(Boolean);
            const generated = parts.join("/");
            setForm((prev) => ({ ...prev, sample_generated: generated }));
            setSampleId(generated);
        }
    }, [form.center_code, form.procedure, form.cycle, form.donor_sperm, form.serial_no]);


    const validateBeforeMove = async () => {
        if (!sampleId.trim()) {
            alert("⚠ Please Select Sample ID first");
            return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
            alert("Unauthorized");
            return;
        }

        try {
            const res = await axios.get(
                `${API_URL}/get_sample_code`,
                {
                    params: { code: sampleId },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            if (res.data.status && res.data.sample_code) {
                dispatch(setSampleCode(sampleId));
                // navigate(`/Update_Male_Details/${res.data.sample_code.sample_master_id}`);

                setSelectedSampleId(res.data.sample_code.sample_master_id); // store sample_master_id
                setPassword("");
                setError("");
                setShowModal(true); // show password modal


            } else {
                alert("Sample ID not match. Please select valid Sample ID");
            }

        } catch (error) {
            console.error(error);
            alert("⚠ Server error");
        }
    };

    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("Unauthorized");
                return;
            }

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password },  // backend uses token to identify user
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // const enc_id = encryptId(selectedSampleId);
            const encryptedId = encryptId(selectedSampleId);
            const safeId = encodeURIComponent(encryptedId);


            if (res.data.success) {
                setShowModal(false);
                // ✅ Navigate to update page if password matches
                // navigate(`/Update_Male_Details/${safeId}`);
                navigate(`/Update_Male_Details/${safeId}`, { replace: true });
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            console.error(err);
            setError("Server error or incorrect password");
        }
    };

    function toRoman(num) {
        const romanMap = [
            { value: 1000, numeral: "M" },
            { value: 900, numeral: "CM" },
            { value: 500, numeral: "D" },
            { value: 400, numeral: "CD" },
            { value: 100, numeral: "C" },
            { value: 90, numeral: "XC" },
            { value: 50, numeral: "L" },
            { value: 40, numeral: "XL" },
            { value: 10, numeral: "X" },
            { value: 9, numeral: "IX" },
            { value: 5, numeral: "V" },
            { value: 4, numeral: "IV" },
            { value: 1, numeral: "I" },
        ];
        let result = "";
        for (const { value, numeral } of romanMap) {
            while (num >= value) {
                result += numeral;
                num -= value;
            }
        }
        return result;
    }




    const romanNumbers = Array.from({ length: 50 }, (_, i) => toRoman(i + 1));
    const isAdmin = loggedUser?.role === "1";

    useEffect(() => {
        const fetchSamples = async () => {
            const token = localStorage.getItem("token");
            if (!token) return;

            try {
                const res = await axios.get(`${API_URL}/patient_report_sample_id_wise`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                let samples = Array.isArray(res.data.literatures) ? res.data.literatures : [];

                // Filter by user_id if normal user
                if (loggedUser?.role !== "1") {
                    samples = samples.filter(sample => sample.user_id === loggedUser.uid);
                }

                setUserList(samples);
                // console.log("Fetched Samples:", samples);

            } catch (err) {
                console.error("Error fetching user list:", err);
                setUserList([]); // fallback
            }
        };

        if (loggedUser) fetchSamples();
    }, [loggedUser]);


    const options = userList.map(sample => ({
        value: sample.male_sample_id,
        label: `${sample.male_sample_id} - ${sample.patient_name}`,
    }));

    // Find the option object that matches sampleId
    const selectedOption = options.find(opt => opt.value === sampleId) || null;

    // const openSampleReport = (flag) => {
    //     const url = `/Patient_report_sample_id_wise/${encodeURIComponent(flag)}`;

    //     window.open(url, "_blank", "noopener,noreferrer");
    // };
    const openSampleReport = (flag) => {
        const url = `/Patient_report_sample_id_wise/${encodeURIComponent(flag)}`;
        navigate(url, { replace: true });
    };

    const deletedFlag = encryptId("deleted");
    const activeFlag = encryptId("active");

    return (
        <Container className="mt-5">
            <Row className="justify-content-center g-4">
                {/* CREATE CARD */}
                <Col md={4}>
                    <Card className=" wave-card shadow-lg p-4 card-hover" style={{ borderRadius: "18px", height: "260px", background: "linear-gradient(135deg,#FFE29F,#FFA99F)" }} onMouseMove={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const y = e.clientY - rect.top;
                        e.currentTarget.style.setProperty('--mouse-x', `${x}px`);
                        e.currentTarget.style.setProperty('--mouse-y', `${y}px`);
                    }}>
                        <div className="text-center d-flex flex-column justify-content-center h-100">
                            <h3 className="fw-bold mb-2">Create</h3>
                            <p className="mb-3">Create a new sample entry</p>
                            <Button className="px-5 py-2 fw-bold rounded-5 border-0" style={{ background: "#ffca7a" }} onClick={() => navigate("/Male_Details")}>
                                Create
                            </Button>
                        </div>
                    </Card>
                </Col>

                {/* UPDATE CARD */}
                <Col md={isAdmin ? 4 : 4}>
                    <Card className="wave-card shadow-lg p-4 card-hover" style={{ borderRadius: "18px", height: "260px", background: "linear-gradient(135deg,#A1C4FD,#C2E9FB)" }} onMouseMove={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const y = e.clientY - rect.top;
                        e.currentTarget.style.setProperty('--mouse-x', `${x}px`);
                        e.currentTarget.style.setProperty('--mouse-y', `${y}px`);
                    }}>
                        <h3 className="fw-bold mb-3 text-center">Update</h3>
                        {/* 
                        <Row className="mb-3 g-2">
                            {isAdmin && (
                                <Col md={2}>
                                    <Form.Select name="center_code" value={form.center_code} onChange={handleFormChange} className="tiny-input no-select-icon">
                                        <option value="" disabled>Center</option>
                                        {center_list.map((center) => (
                                            <option
                                                key={center.center_code}
                                                value={`${center.center_code}/PIWIL`}
                                            >
                                                {center.center_code}
                                            </option>
                                        ))}

                                    </Form.Select>
                                </Col>
                            )}

                            <Col md={isAdmin ? 2 : 3}>
                                <Form.Select name="procedure" value={form.procedure} onChange={handleFormChange} className="tiny-input no-select-icon">
                                    <option value="" disabled>Procedure</option>
                                    <option value="IUI">IUI</option>
                                    <option value="IVF">IVF</option>
                                    <option value="ICSI">ICSI</option>
                                </Form.Select>
                            </Col>

                            <Col md={isAdmin ? 3 : 3}>
                                <Form.Select name="cycle" value={form.cycle} onChange={handleFormChange} className="tiny-input no-select-icon">
                                    <option value="" disabled>Cycle</option>
                                    {romanNumbers.map((r) => (
                                        <option key={r} value={r}>{r}</option>
                                    ))}

                                </Form.Select>
                            </Col>

                            <Col md={isAdmin ? 2 : 3}>
                                <Form.Select name="donor_sperm" value={form.donor_sperm} onChange={handleFormChange} className="tiny-input no-select-icon">
                                    <option value="" disabled>Donor</option>
                                    <option value="D">Yes</option>
                                    <option value="N">No</option>
                                </Form.Select>
                            </Col>

                            <Col md={isAdmin ? 3 : 3}>
                                <Form.Control type="text" name="serial_no" value={form.serial_no} onChange={handleFormChange} className="tiny-input" placeholder="Serial No" />
                            </Col>
                        </Row> */}
                        <Row className="mt-1 align-items-left justify-content-left g-1">
                            <Col xs={12} md={12}>
                                <Select
                                    value={selectedOption}
                                    onChange={(selected) => setSampleId(selected ? selected.value : "")}
                                    options={options}
                                    placeholder="Search Sample"
                                    isClearable
                                    classNamePrefix="select"
                                    styles={{
                                        control: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: 'white',
                                            borderColor: state.isFocused ? '#2684FF' : '#ced4da',
                                            boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                                            borderRadius: 8,
                                            minHeight: 38,
                                            padding: '2px 8px',
                                            fontSize: 14,
                                        }),

                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#212529',
                                            fontWeight: 600,
                                        }),
                                        // ... other styles as before
                                    }}
                                />
                            </Col>


                        </Row>

                        <Row className="mt-4 align-items-left justify-content-left g-3">
                            {/* <Col xs={12} md={8}>
                                <Form.Control type="text" name="sample_generated" value={form.sample_generated} onChange={(e) => {
                                    setIsManualSample(true);
                                    setForm(prev => ({ ...prev, sample_generated: e.target.value }));
                                    setSampleId(e.target.value);
                                }} className="sample-box" />
                            </Col> */}
                            <Col xs={12} md={4} className="text-center">
                                <Button className="w-100 py-2 fw-bold rounded-4 border-0" style={{ background: "#7fb6ff" }} onClick={validateBeforeMove}>
                                    Update
                                </Button>
                            </Col>
                            <Col xs={12} md={8} className="text-center">



                                {/* <Button
                                    className="w-100 py-2 fw-bold rounded-4 border-0" title="List of Registered Samples"
                                    style={{ background: "#33a41fd1" }}
                                    onClick={() =>
                                        window.open(
                                            `/Patient_report_sample_id_wise/${encodeURIComponent(activeFlag)}`,
                                            "_blank"
                                        )
                                    }
                                >
                                    Registered Samples
                                </Button> */}

                                <Button
                                    className="w-100 py-2 fw-bold rounded-4 border-0"
                                    title="List of Registered Samples"
                                    style={{ background: "#33a41fd1" }}
                                    onClick={() => openSampleReport(activeFlag)}
                                >
                                    Registered Samples
                                </Button>
                            </Col>

                        </Row>

                    </Card>
                </Col>
                <Col md={4}>
                    <Card className=" wave-card shadow-lg p-4 card-hover" style={{ borderRadius: "18px", height: "260px", background: "linear-gradient(135deg,#2193B0,#6DD5ED)" }} onMouseMove={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const x = e.clientX - rect.left;
                        const y = e.clientY - rect.top;
                        e.currentTarget.style.setProperty('--mouse-x', `${x}px`);
                        e.currentTarget.style.setProperty('--mouse-y', `${y}px`);
                    }}>
                        <div className="text-center d-flex flex-column justify-content-center h-100">
                            <h3 className="fw-bold mb-2">Deleted Samples</h3>


                            {/* <Button
                                className="mt-5 px-5 py-2 fw-bold rounded-5 border-0"
                                style={{ background: "#e91313" }}
                                onClick={() =>
                                    window.open(
                                        `/Patient_report_sample_id_wise/${encodeURIComponent(deletedFlag)}`,
                                        "_blank"
                                    )
                                }
                            >                                Deleted Samples
                            </Button> */}

                            <Button
                                className="mt-5 px-5 py-2 fw-bold rounded-5 border-0"
                                style={{ background: "#e91313" }}
                                onClick={() => openSampleReport(deletedFlag)}
                            >
                                Deleted Samples
                            </Button>
                        </div>
                    </Card>
                </Col>
            </Row>

            <style>{`
        .tiny-input {
                    font-size: 12px;
                    height: 30px;            
                    padding: 4px 10px;
                    border-radius: 6px;
                    width: 100%;
                    min-width: 90px;
                    line-height: 1.2;
                    box-sizing: border-box;
                    }

                  
       

                    /* Remove select arrow */
                    .no-select-icon {
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: none !important;
                    }       
                    }.unit-input .form-control {
    border-right: 0;
}

.unit-input .unit-text {
    background-color: #fff;
    border-left: 1px solid #ced4da;
    font-weight: 500;
    min-width: 80px;
    justify-content: center;
}



/* When a real value is selected */

/* Disabled option styling */
.form-select:valid {
  color: #000;
}
  .form-select option[disabled] {
  color: #9aa0a6;
}


.soft-modal .modal-content {
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 10px 30px rgba(0,0,0,0.12);
    border: none;
    overflow: hidden;
}
.wave-card {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.wave-card::before {
  content: '';
  position: absolute;
  top: var(--mouse-y, 50%);
  left: var(--mouse-x, 50%);
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(255,255,255,0.4) 0%, transparent 80%);
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease, opacity 0.3s ease;
  pointer-events: none;
  opacity: 0;
}

.wave-card:hover::before {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

.wave-card:hover {
  transform: translateY(-5px);
}
      `}</style>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your authorization key
                        </Form.Label>

                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="new-password"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>

            </Modal>
        </Container>
    );
}
